var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useRef } from 'react';
import KB from '@kb/global-context';
import Button, { ButtonDisplayType } from '@ocp/button';
import DropDown from '@ocp/dropdown';
import { TooltipProvider } from '@ocp/tooltip';
import { useButtons, useHiddenButtons } from '../../hooks/index';
import BurgerButton, { DrawerList, DropDownList } from '../BurgerButton/index';
import styles from './ButtonsGroup.module.scss';
const ButtonsGroup = ({ classNameId, classPk, deviceType, panelMode, params, onMutate, }) => {
    const buttonsData = useMemo(() => {
        const { contentClassNameId, contentClassPk, showActions } = params, buttons = __rest(params, ["contentClassNameId", "contentClassPk", "showActions"]);
        return buttons;
    }, [params]);
    const containerRef = useRef(null);
    const [shownButtons, hiddenButtons] = useHiddenButtons(buttonsData, containerRef);
    const buttons = useButtons({
        classNameId,
        classPk,
        deviceType,
        panelMode,
    }, buttonsData, shownButtons, hiddenButtons, containerRef, onMutate);
    const getItemList = (button) => {
        const trigger = (React.createElement(Button, { key: button.order, title: button.title, symbol: button.symbol, displayType: ButtonDisplayType.Fourth }));
        return (KB.isMobile ? (React.createElement(DrawerList, { trigger: trigger, items: button.items, key: button.order })) : (React.createElement(DropDown, { trigger: trigger, closeOnClick: true, key: button.order },
            React.createElement(DropDownList, { items: button.items }))));
    };
    return (React.createElement(TooltipProvider, null,
        React.createElement("div", { className: styles.buttons, ref: containerRef },
            buttons.map((button) => (button.items ? (getItemList(button)) : (React.createElement(Button, { key: button.order, title: button.title, symbol: button.symbol, onClick: button.onClick, displayType: ButtonDisplayType.Fourth })))),
            params.showActions && (React.createElement(BurgerButton, { classNameId: params.contentClassNameId, classPk: params.contentClassPk, deviceType: deviceType, panelMode: panelMode, hiddenButtons: hiddenButtons, shownButtons: shownButtons })))));
};
export default ButtonsGroup;
